import publicInstall from "./index_public"
import store from '@/common/vuex/store_rt'

export default {
  install(Vue) {
    publicInstall.install(Vue);

    PF.createVue = function(config) {
        config.store = store;
        return new Vue(config);
    };
  }
};



// WEBPACK FOOTER //
// ./src/common/components/index_rt.js